import { firebaseConfig } from '@/config';
import DOMPurify from 'dompurify';

// /**
//  * Sanitizes the provided HTML string to prevent XSS attacks.
//  * @param html - The HTML string to sanitize.
//  * @returns The sanitized HTML string.
//  */
// export function sanitizeHtml(html: string): string {
//     return DOMPurify.sanitize(html);
// }

export { DOMPurify };

const {databaseURL, storageBucket} = firebaseConfig;

// Helper to extract hostname from a URL or return as-is if already a domain
function extractHostname(value: string): string {
    try {
        // Handle gs:// URLs for storageBucket
        if (value.startsWith('gs://')) {
            // Remove gs:// and return the rest
            return value.replace('gs://', '');
        }
        // Otherwise, try to parse as URL
        const url = new URL(value);
        return url.hostname;
    } catch {
        // If parsing fails, assume it's already a domain
        return value;
    }
}

const allowedDomains = [
    'storage.googleapis.com',
    'byzzer.ai',
    extractHostname(storageBucket),
    extractHostname(databaseURL)
];
/**
 * Validates and sanitizes a URL for use in href/src attributes.
 * Only allows http(s) and blob URLs from trusted domains.
 */
export function sanitizeUrl(url: string): string | null {
    try {
        const parsed = new URL(url, window.location.origin);
        const allowedProtocols = ['https:', 'http:', 'blob:'];

        if (!allowedProtocols.includes(parsed.protocol)) return null;

        // If not a blob, check domain
        if (parsed.protocol !== 'blob:' && allowedDomains.length > 0) {
            if (!allowedDomains.some(domain =>
                parsed.hostname === domain ||
                parsed.hostname.endsWith('.' + domain)
            )) {
                return null;
            }
        }

        return parsed.href;
    } catch {
        return null;
    }
}